import type { UserRole } from '#shared/types/auth'

export const useAdmin = () => {
  const authUser = useAuthUser()

  return computed(() => {
    console.group('👑 Admin Check')
    if (!authUser.value) {
      console.log('No user logged in')
      console.groupEnd()
      return false
    }

    const isAdmin = authUser.value.roles?.includes('ADMIN' as UserRole) ?? false
    console.log('Admin check result:', isAdmin)
    console.groupEnd()
    return isAdmin
  })
}
